import { ResponsiveCarousel } from "../customplugins/carousel.js";
import { Lightbox } from "../customplugins/Lightbox.js";

document.addEventListener("DOMContentLoaded", () => {
    const carouselTrackElement = document.getElementById("carouselTrack");
    if (carouselTrackElement) {
        new ResponsiveCarousel("carouselTrack", {
            loop: true,
            margin: 20,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000, 
            responsive: {
                0: { items: 1 },
                600: { items: 1 },
                1000: { items: 1 }
            }
        });
    }

    const categoriesElement = document.getElementById("Categories");

    if (categoriesElement) {
        new ResponsiveCarousel("Categories", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 3 },
                1000: { items: 4 }
            }
        });
    }

    const bestsellersElement = document.getElementById("bestsellers");

    if (bestsellersElement) {
        new ResponsiveCarousel("bestsellers", {
            
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 3 },
                1000: { items: 4 }
            }
        });
    }
    const Testimonials = document.getElementById("Testimonials");

    if (Testimonials) {
        new ResponsiveCarousel("Testimonials", {

            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 3 },
                1000: { items:3 }
            }
        });
    }


    const watchbuy = document.getElementById("watchbuy");

    if (watchbuy) {
        new ResponsiveCarousel("watchbuy", {

            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1 },
                600: { items: 3 },
                1000: { items: 4 }
            }
        });
    }


    const heilightslider = document.getElementById("heilightslider");

    if (heilightslider) {
        new ResponsiveCarousel("heilightslider", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 4 },
                1000: { items: 5 }
            }
        });
    }
    const blogcardfull3 = document.getElementById("blogcardfull3");

    if (blogcardfull3) {
        new ResponsiveCarousel("blogcardfull3", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 2.2 },
                1000: { items: 3 }
            }
        });
    }
   
    const lightboxElements =
        document.querySelectorAll<HTMLElement>("[data-lightbox]");

    if (lightboxElements.length > 0) {
        Lightbox.init({
            selector: "[data-lightbox]",
            keyboard: true,
            navigation: true,
            animation: true,
            loop: true
        });
    }
    

})